<template>
  <BlockTypeHero          v-if="type === 'hero'"          :block="block" />
  <BlockTypeBlurb         v-if="type === 'blurb'"         :block="block" />
  <BlockTypeCalendar      v-if="type === 'calendar'"      :block="block" />
  <BlockTypeHeading       v-if="type === 'heading'"       :block="block" />
  <BlockTypeText          v-if="type === 'text'"          :block="block" />
  <BlockTypeImage         v-if="type === 'image'"         :block="block" :context="context" />
  <BlockTypeGallery       v-if="type === 'gallery'"       :block="block" :context="context" />
  <BlockTypeQuote         v-if="type === 'quote'"         :block="block" />
  <BlockTypeCta           v-if="type === 'cta'"           :block="block" />
  <BlockTypeTimeline      v-if="type === 'timeline'"      :block="block" />
  <BlockTypeFeatured      v-if="type === 'featured'"      :block="block" />
  <BlockTypeNews          v-if="type === 'news'"          :block="block" />
  <BlockTypeCalendarMonth v-if="type === 'calendarmonth'" :block="block" />
  <BlockTypeNewsYear      v-if="type === 'newsyear'"      :block="block" />
</template>

<script setup>
const props = defineProps({
  block:   { type: Object, required: true,  default: () => ({}) },
  context: { type: Object, required: false, default: () => ({}) },
})
const type = computed(() => props.block?.type)
</script>
